import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { WrapRootElement } from "./src/provider";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import i18n from "./src/i18n";

import '@fontsource/syncopate';
import '@fontsource/raleway';
import '@fontsource/quicksand';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <HelmetProvider>
    <I18nextProvider i18n={i18n}>
      <WrapRootElement element={element} />
    </I18nextProvider>
  </HelmetProvider>
);
export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (location.pathname === '/dev-404-page/') {
    window.location.replace('/404');
  }
};

export const onInitialClientRender = () => {};